module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/FI-8e604ada240fc236ec6aa126de9afc0b.png";